import request from '@/http/request'

export const API_URL_SETTLEMENT_ACCOUNT_LIST = '/api/mchSettlementAccount/list'
export const API_URL_SETTLEMENT_ACCOUNT_DETAIL = '/api/mchSettlementAccount/detail'
export const API_URL_SETTLEMENT_ACCOUNT_ADD = '/api/mchSettlementAccount/add'
export const API_URL_SETTLEMENT_ACCOUNT_UPDATE = '/api/mchSettlementAccount/update'
export const API_URL_SETTLEMENT_ACCOUNT_DELETE = '/api/mchSettlementAccount/delete'

export const API_URL_SETTLEMENT_APPLICATION_LIST = '/api/mchSettlementApplication/list'

export const API_URL_SETTLEMENT_APPLICATION_DETAIL = '/api/mchSettlementApplication/detail'
export const API_URL_SETTLEMENT_APPLICATION_ADD = '/api/mchSettlementApplication/add'
export const API_URL_SETTLEMENT_APPLICATION_UPDATE = '/api/mchSettlementApplication/update'
export const API_URL_SETTLEMENT_APPLICATION_DELETE = '/api/mchSettlementApplication/delete'

// 根据条件分页查询结算账户列表
export function getSettlementAccountList (data) {
  return request.request({ url: '/api/mchSettlementAccount/list', method: 'POST', data: data })
}
// 基于主键ID查看结算账户详情

export function getSettlementAccountDetail (params) {
  return request.request({ url: '/api/mchSettlementAccount/detail', method: 'GET', params })
}

// 新增结算账户
export function addSettlementAccount (data) {
  return request.request({ url: '/api/mchSettlementAccount/add', method: 'POST', data })
}

// 基于主键ID更新结算账户
export function updateSettlementAccount (data) {
  return request.request({ url: '/api/mchSettlementAccount/update', method: 'POST', data })
}

// 基于主键ID删除结算账户
export function deleteSettlementAccount (data) {
  return request.request({ url: '/api/mchSettlementAccount/delete', method: 'DELETE', data })
}

// 基于商户号查询可申请结算的金额
export function getAvailableSettlementAmount (params) {
  return request.request({ url: '/api/mchSettlementApplication/getAvailableSettlementAmount', method: 'GET', params })
}

// /api/mchSettlementApplication/applySettlement
// 发起结算申请
/**
 *
 * @param {*} data
 * settlementAccountId 结算账户ID
 * settlementAmount  结算金额
 * fee 手续费, 没有传0
 * 发起结算申请
 * @returns
 */
export function applySettlement (data) {
  return request.request({ url: '/api/mchSettlementApplication/applySettlement', method: 'POST', data })
}

// 条件分页查询结算申请列表
export function getApplyList (data) {
  return request.request({ url: '/api/mchSettlementApplication/list', method: 'POST', data })
}

// 基于主键ID查看结算申请详情
//  /api/mchSettlementApplication/detail
export function getSettlementApplicationDetail (id) {
  return request.request({
    url: '/api/mchSettlementApplication/detail',
    method: 'GET',
    params: { id }
  })
}
